import { BASE_URL } from '../constants';
export default class HitSender {
    /**
     * Instantiate HitSender.
     * @param {String} endpoint Name of the component.
     * @param {String} baseURL Optional target URL to which further data may be appended.
     */
    constructor(endpoint, baseUrl) {
        this.target = '';
        this.isFirst = true;
        this.maxLength = 2048;
        this.target = `${baseUrl || BASE_URL}/${endpoint}`;
    }
    delimiter() {
        if (this.isFirst) {
            this.isFirst = false;
            return '?';
        }
        return '&';
    }
    append(addition) {
        const newTarget = this.target + this.delimiter() + addition;
        if (newTarget.length < this.maxLength) {
            this.target = newTarget;
        }
    }
    encode(value) {
        return encodeURIComponent(value);
    }
    /**
     * Add query parameter to the URL.
     * @param {String} key
     * @param {String} value
     * @return {HitSender} Current instance is returned to allow method chaining.
     */
    appendValue(key, value) {
        this.append(this.encode(key) + '=' + this.encode(value));
        return this;
    }
    /**
     * Send GET request to the target.
     */
    send() {
        const pixel = new Image();
        pixel.src = this.target;
    }
}
